import Logo from "../assets/logo1.svg";
import CoffeeGroup from "../assets/coffeegroup.svg";
import { useEffect, useRef, useState } from "react";
import TextInput from "../components/TextInput";
import SelectInput from "../components/Select";
import { Link } from "react-router-dom";
import LoadingComponent from "../components/Loading";
import { IoLogoWhatsapp } from "react-icons/io";

const BUSSINESS_KIND_OPTIONS = [
  { value: "Academia", label: "Academia" },
  {
    value: "Clínica/Consultório de Fisioterapia",
    label: "Clínica/Consultório de Fisioterapia",
  },
  { value: "Home care (atendo em casa)", label: "Home care (atendo em casa)" },
  { value: "Estúdio de Pilates", label: "Estúdio de Pilates" },
  { value: "Estudante de Fisioterapia", label: "Estudante de Fisioterapia" },
  { value: "Clínica de outra área", label: "Clínica de outra área" },
  { value: "Outros", label: "Outros" },
];

const ROLE_OPTIONS = [
  { value: "Proprietário(a)", label: "Proprietário(a)" },
  { value: "Administrador(a)", label: "Administrador(a)" },
  { value: "Realizo atendimentos", label: "Realizo atendimentos" },
  { value: "Recepcionista", label: "Recepcionista" },
  { value: "Outra", label: "Outra" },
];

const TEAM_SIZE_OPTIONS = [
  { value: "Individual", label: "Individual" },
  { value: "Pequena (1-5 membros)", label: "Pequena (1-5 membros)" },
  { value: "Média (6-15 membros)", label: "Média (6-15 membros)" },
  { value: "Grande (16-30 membros)", label: "Grande (16-30 membros)" },
  {
    value: "Muito grande (mais de 30 membros)",
    label: "Muito grande (mais de 30 membros)",
  },
  { value: "Não sei", label: "Não sei" },
];

const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const validateName = (name) => {
  const nameParts = name.trim().split(/\s+/);
  return nameParts.length >= 2;
};

const formatPhone = (value) => {
  const numbers = value.replace(/\D/g, "");

  if (numbers.length <= 2) {
    return numbers;
  } else if (numbers.length <= 6) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
  } else if (numbers.length <= 10) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(
      6
    )}`;
  } else {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(
      7,
      11
    )}`;
  }
};

export default function Sorteio() {
  const [pageArea, setPageArea] = useState("participate");
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      if (pageArea === "participate") {
        document.title = "Promoção 3 corações - Sonafe 2025";
      }

      if (pageArea === "finished") {
        document.title = "Grupo VIP - Sonafe 2025";
      }
    }, [pageArea]);

  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, [pageArea]);

  const [participant, setParticipant] = useState({
    name: "",
    email: "",
    phone: "",
    business_kind: "",
    role: "",
    team_number: "",
  });

  const createUser = async () => {
    setIsLoading(true);
    setErrors({});

    try {
      const response = await fetch(
        "https://app.sistemascal.com.br/api/affiliates/affiliate_referrals",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Email: participant.email,
            Nome: participant.name,
            Telefone: participant.phone,
            key: "SONAFE2025",
            "Qual o seu tipo de negócio?": participant.business_kind,
            "Qual a sua função?": participant.role,
            "Qual o tamanho da equipe?": participant.team_number,
          }),
        }
      );

      if (response.ok) {
        setPageArea("finished");
      } else {
        const data = await response.json().catch(() => ({}));
        setErrors({
          formSubmission:
            data.message ||
            "Não foi possível enviar o formulário. Tente novamente.",
        });
      }
    } catch (error) {
      console.error("Erro ao enviar formulário:", error);

      setErrors({
        formSubmission: "Ocorreu um erro ao enviar o formulário.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!participant.name.trim()) {
      newErrors.name = "Nome completo é obrigatório";
    } else if (!validateName(participant.name)) {
      newErrors.name = "Digite nome e sobrenome (mínimo 2 partes)";
    }

    if (!participant.email.trim()) {
      newErrors.email = "E-mail é obrigatório";
    } else if (!validateEmail(participant.email)) {
      newErrors.email = "Digite um e-mail válido";
    }

    if (!participant.phone.trim()) {
      newErrors.phone = "WhatsApp é obrigatório";
    } else if (participant.phone.replace(/\D/g, "").length < 10) {
      newErrors.phone = "Digite um número de telefone válido";
    }

    if (!participant.business_kind) {
      newErrors.business_kind = "Tipo de negócio é obrigatório";
    }
    if (!participant.role) {
      newErrors.role = "Função é obrigatória";
    }
    if (!participant.team_number) {
      newErrors.team_number = "Tamanho da equipe é obrigatório";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleBlur = (field) => {
    setTouched({ ...touched, [field]: true });
  };

  const handleChange = (field, value) => {
    setParticipant({ ...participant, [field]: value });

    if (errors[field]) {
      setErrors({ ...errors, [field]: "" });
    }
  };

  const handlePhoneChange = (value) => {
    const formattedPhone = formatPhone(value);
    handleChange("phone", formattedPhone);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const allTouched = {
      name: true,
      email: true,
      phone: true,
      business_kind: true,
      role: true,
      team_number: true,
    };
    setTouched(allTouched);

    if (validateForm()) {
      createUser();
    } else {
      // alert("Por favor, corrija os erros no formulário.", errors);
    }
  };

  const formRef = useRef();

  return (
    <main className="flex-1 h-auto min-h-screen flex flex-col items-center justify-between bg-white w-full">
      {isLoading && <LoadingComponent />}
      <div className="w-full max-w-[720px] flex flex-col items-center px-4 pt-6">
        <header className="w-full flex items-center justify-center mb-8">
          <Link
            to="/"
            className="w-full flex items-center justify-center cursor-pointer"
          >
            <img
              src={Logo}
              alt="ScalLogo"
              className="w-32 sm:w-40 md:w-48 lg:w-56 h-auto object-contain"
            />
          </Link>
        </header>
        {pageArea === "participate" && (
          <section className="w-full py-8 px-6 sm:px-8 rounded-2xl flex flex-col gap-4 bg-green70 items-center text-center mt-4">
            <span className="text-2xl sm:text-3xl text-white font-museo max-w-[90%]">
              <span className="text-greenNeon">Participe do Sorteio da </span>
              Máquina de Café 3 Corações{" "}
              <span className="text-greenNeon">no SONAFE 2025!</span>
            </span>
            <span className="text-lg sm:text-xl text-white font-museo max-w-[80%]">
              Serão 4 sorteios, 1 vez por dia!
            </span>
            <img
              src={CoffeeGroup}
              alt="Cafeteira tres corações"
              className="w-full object-cover"
            />
            <span className="text-lg sm:text-xl text-white font-museo max-w-[70%]">
              Cadastre-se uma única vez e concorra automaticamente
            </span>

            <button
              onClick={() =>
                formRef.current?.scrollIntoView({ behavior: "smooth" })
              }
              className="w-full py-6 bg-greenNeon2 rounded-md text-default font-bold mt-8 hover:bg-greenNeon transition-colors duration-1000"
            >
              Participar do Sorteio
            </button>
          </section>
        )}
        {pageArea === "participate" && (
          <section className="w-full py-8 px-2 text-center rounded-2xl flex flex-col gap-4  items-center">
            <span className="text-4xl font-museo text-default">
              Como funciona a promoção?
            </span>
            <div className="flex flex-col w-full md:w-4/5 gap-8 my-6">
              <span className="font-funnel  text-center flex items-center justify-center text-xl">
                🎁 Uma nova chance de ganhar todos os dias!
              </span>
              <span className="font-funnel text-xl">
                A cada dia do evento SONAFE 2025, sortearemos uma máquina de
                café Touch 3 Corações entre os inscritos.
              </span>
              <span className="font-funnel text-xl">
                Com um único cadastro, você já está participando dos quatro
                sorteios!
              </span>
            </div>
            <span ref={formRef} className="text-4xl font-museo text-default">
              Cadastre-se grátis
            </span>
            <form
              onSubmit={handleSubmit}
              className="w-full md:w-4/5 px-2 mt-4 gap-6 flex flex-col"
            >
              <TextInput
                label="Nome completo"
                placeholder="Insira o seu nome completo"
                type="text"
                value={participant.name}
                onChange={(e) => handleChange("name", e.target.value)}
                onBlur={() => handleBlur("name")}
                error={touched.name && errors.name}
                required
              />
              <TextInput
                label="E-mail"
                placeholder="Digite o seu e-mail"
                type="email"
                value={participant.email}
                onChange={(e) => handleChange("email", e.target.value)}
                onBlur={() => handleBlur("email")}
                error={touched.email && errors.email}
                required
              />
              <TextInput
                label="WhatsApp"
                placeholder="(00) 00000-0000"
                type="tel"
                value={participant.phone}
                onChange={(e) => handlePhoneChange(e.target.value)}
                onBlur={() => handleBlur("phone")}
                error={touched.phone && errors.phone}
                required
              />
              <SelectInput
                label="Tipo de negócio"
                placeholder="Selecione"
                value={participant.business_kind}
                onChange={(e) => handleChange("business_kind", e.target.value)}
                onBlur={() => handleBlur("business_kind")}
                error={touched.business_kind && errors.business_kind}
                options={BUSSINESS_KIND_OPTIONS}
                required
              />

              <SelectInput
                label="Sua função no estabelecimento"
                placeholder="Selecione"
                value={participant.role}
                onChange={(e) => handleChange("role", e.target.value)}
                onBlur={() => handleBlur("role")}
                error={touched.role && errors.role}
                options={ROLE_OPTIONS}
                required
              />
              <SelectInput
                label="Tamanho da equipe"
                placeholder="Selecione"
                value={participant.team_number}
                onChange={(e) => handleChange("team_number", e.target.value)}
                onBlur={() => handleBlur("team_number")}
                error={touched.team_number && errors.team_number}
                options={TEAM_SIZE_OPTIONS}
                required
              />
              <span className="text-sm text-default text-left font-funnel">
                Ao se cadastrar, você concorda em participar da promoção e
                autoriza o Scal a utilizar seus dados para comunicações
                relacionadas à plataforma, conforme a nossa{" "}
                <a className="text-default underline" href="www">
                  Política de Privacidade
                </a>
              </span>
              {errors && errors.formSubmission && (
                <span className="text-sm text-red-600 text-left font-funnel">
                  {errors.formSubmission}
                </span>
              )}
              <button
                type="submit"
                className="w-full py-6 bg-greenNeon2 text-xl rounded-md text-default font-bold mt-8 hover:bg-greenNeon transition-colors duration-1000"
              >
                Realizar inscrição
              </button>
            </form>
          </section>
        )}
        {pageArea === "finished" && (
          <section className="w-full flex flex-col items-center justify-center flex-1 h-auto grow text-center px-6 py-10">
            <div className="w-full max-w-md bg-[#0F271F] rounded-3xl p-10 px-6 flex flex-col items-center justify-center gap-6">
              <div className="w-28 h-28 flex items-center justify-center rounded-full bg-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="#0F271F"
                  className="w-16 h-16"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>

              <div className="flex flex-col items-center gap-3 font-funnel">
                <span className="text-[#9DFF6E] text-2xl font-museo">
                  Parabéns, você agora está participando do sorteio.
                </span>
                <span className="text-white text-lg font-funnel leading-snug">
                  Para acompanhar o resultado, entre no grupo do WhatsApp
                </span>
              </div>

              <a
                href="https://chat.whatsapp.com/DnKdGti7XauFTa90tbHVFu?mode=wwc"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 bg-[#A7FF4A] text-[#0F271F] font-bold text-lg w-full py-4 rounded-md flex items-center justify-center gap-2 hover:bg-[#9DFF6E] transition-colors duration-300"
              >
                <IoLogoWhatsapp />
                Conferir o resultado
              </a>
            </div>
          </section>
        )}
      </div>

      <footer className="w-full flex justify-center ">
        <div className="w-full max-w-[720px] h-40 flex items-center justify-center bg-[#F5F5F5]">
          <img
            src={Logo}
            alt="ScalLogo"
            className="w-24 sm:w-32 h-auto object-contain"
          />
        </div>
      </footer>
    </main>
  );
}
